export default __webpack_public_path__ + "static/media/contact-book.236b02cd.svg";